import { ContentManagerModule } from '@2sic.com/sxc-angular';
import { Component, inject, input } from '@angular/core';
import { Categories, FileData, Software } from '../downloadsModel';
import { ToolbarHelperService } from '../toolbar-helper.service';

@Component({
  selector: 'app-software',
  imports: [ContentManagerModule],
  templateUrl: './software.component.html',
  styleUrl: './software.component.scss',
})
export class SoftwareComponent {
  toolbarHelperSvc = inject(ToolbarHelperService);

  items = input.required<Software[]>();
  categoryInfo = input.required<Categories>();

  groupItemsBySpecific(items: Software[]): { isSpecific: boolean; downloads: FileData[] }[] {
    if (!items?.length) return [];

    // first, sort alphabetically by Title
    const sorted = [...items].sort((a, b) => a.Title.localeCompare(b.Title));

    // group by IsSpecificSoftwareImplementation
    const groupedMap: Record<string, FileData[]> = {};
    for (const f of sorted) {
      const key = f.IsSpecificSoftwareImplementation ? 'true' : 'false';
      (groupedMap[key] ??= []).push(f);
    }

    // convert the grouped object into an array suitable for the template
    return Object.entries(groupedMap).map(([key, downloads]) => ({
      isSpecific: key === 'true',
      downloads,
    }));
  }
}
